// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__PRu7g","spinnerCircle":"Spinner_spinnerCircle__zCC2o","spin":"Spinner_spin__tSpDs"};